import {monthNames} from '@/library/date';

export const WORK_STATES: Record<string, SelectOption> = {
    permanent: {
        value: 'permanent',
        label: 'Festangestellter',
    },
    apprentice: {
        value: 'apprentice',
        label: 'Auszubildender',
    },
    student: {
        value: 'student',
        label: 'Student/in',
    },
    intern: {
        value: 'intern',
        label: 'Praktikant/in',
    },
    pupil: {
        value: 'pupil',
        label: 'Schüler/in',
    },
    freelance: {
        value: 'freelance',
        label: 'Selbstständige/r',
    },
    volunteer: {
        value: 'volunteer',
        label: 'Ehrenamt',
    },
    helper_employee: {
        value: 'helper_employee',
        label: 'Aushilfskraft',
    },
    fixed_term_employee: {
        value: 'fixed_term_employee',
        label: 'Befristete/r Mitarbeiter/in',
    },
    temporary_employee: {
        value: 'temporary_employee',
        label: 'Zeitarbeitskraft',
    },
    external: {
        value: 'external',
        label: 'Extern',
    },
    diploma_student: {
        value: 'diploma_student',
        label: 'Diplomand/in',
    },
    phd_student: {
        value: 'phd_student',
        label: 'Doktorand/in',
    },
    beneficiary: {
        value: 'beneficiary',
        label: 'Versorgungsempfänger/in',
    },
    military_service: {
        value: 'military_service',
        label: 'Wehrdienst / Zivildienst',
    },
    other: {
        value: 'other',
        label: 'Sonstige',
    },
    end: {
        value: 'end',
        label: 'Arbeitsende',
    },
};

export const WORK_STATE_OPTIONS: SelectOption[] = Object.values(WORK_STATES);

export const RESIDENCE_PERMIT_OPTIONS = {
    0: 'Nicht notwendig',
    1: 'Nein',
    2: 'Ja',
};

export const vacationStates = {
    open: 0,
    accepted: 1,
    declined: 2,
    revoked: 3,
    startValue: 4,
    additionalDay: 5,
};

export const educationStates = {
    missing: -1,
    none: 0,
    accepted: 1,
    rejected: 2,
};

export const EDUCATION_STATE_TAGS = {
    [educationStates.missing]: {
        text: 'Eintrag fehlt',
        icon: 'priority_high',
        iconClass: 'text-danger',
    },
    [educationStates.accepted]: {
        text: 'Akzeptiert',
        icon: 'check',
        iconClass: 'text-success',
    },
    [educationStates.none]: {
        text: 'Eingereicht',
        icon: 'hourglass_empty',
        iconClass: 'text-warning',
    },
    [educationStates.rejected]: {
        text: 'Eintrag wurde abgelehnt',
        icon: 'do_disturb',
        iconClass: 'text-danger',
    },
};

export const sickNoteStates = {
    none: 0,
    noUpload: 1,
    checking: 2,
    done: 3,
    rejected: 4,
};

export const SICK_NOTE_STATE_TAGS = {
    [sickNoteStates.noUpload]: {
        tagText: 'Nicht eingereicht',
        tagClass: 'tag-error',
        icon: 'clear',
    },
    [sickNoteStates.checking]: {
        tagText: 'Wird geprüft',
        tagClass: 'tag-editing',
        icon: 'error_outline',
    },
    [sickNoteStates.done]: {
        tagText: 'Überprüft',
        tagClass: 'tag-active',
        icon: 'done',
    },
    [sickNoteStates.rejected]: {
        tagText: 'Ungültig',
        tagClass: 'tag-error',
        icon: 'priority_high',
    },
    [sickNoteStates.none]: {},
};

export const SCHOOL_EDUCATION_OPTIONS = {
    1: 'Ohne Abschluss',
    2: 'Haupt-/Volksschulabschluss',
    3: 'Mittlere Reife oder gleichwertig',
    4: 'Abitur/Fachabitur',
    5: 'Abschluss unbekannt',
};

export const VOCATIONAL_EDUCATION_OPTIONS = {
    1: 'ohne berufliche Ausbildung',
    2: 'Abschluss einer anerkannten Berufsausbildung',
    3: 'Meister/Techniker',
    4: 'Bachelor',
    5: 'Diplom/Magister/Master/Staatsexamen',
    6: 'Promotion',
    7: 'Abschluss unbekannt',
};

export const TAX_CLASS_OPTIONS = {
    0: 'Nicht angegeben',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
};

export const INSIGHT_ATTRIBUTES: Record<string, any> = {
    class: 'free-version-disabled',
    title: 'Diese Funktion steht in der kostenpflichtigen Version zur Verfügung.',
};

export const INSIGHT_APP_ATTRIBUTES: Record<string, any> = {
    class: 'free-version-disabled',
    title: 'Diese Funktion setzt die Freischaltung der Mitarbeiter-App voraus.',
};

export const EXPERTISE_CHARACTERISTICS_OPTIONS = {
    0: 'Keine Kenntnisse',
    1: 'Grundkenntnisse',
    2: 'Fortgeschritten',
    3: 'Experte',
};

export const COMPETENCE_CHARACTERISTICS_OPTIONS = {
    0: 'Entwicklungsbedarf',
    1: 'Vorhanden',
    2: 'Ausgeprägt',
    3: 'Stark ausgeprägt',
};

export const LANGUAGE_CHARACTERISTICS_OPTIONS = {
    0: 'Keine Kenntnisse',
    1: 'Grundkenntnisse',
    2: 'Fortgeschritten',
    3: 'Verhandlungssicher',
    4: 'Muttersprache',
};

export const DRIVING_CHARACTERISTICS_OPTIONS = {
    0: 'Nicht vorhanden',
    1: 'Vorhanden',
};

export const FINANCE_BANK_ACCOUNT_PAYMENT_METHOD_OPTIONS = {
    0: 'Überweisung',
    1: 'Bar',
    2: 'Scheck',
    3: 'Kein Zahlungsverkehr',
};

export const BILLING_TYPE_OPTIONS = {
    0: 'Stundenlöhner',
    1: 'Gehaltsempfänger',
};

export const EMPLOYEE_LEASING_OPTIONS: SelectOption[] = [
    {
        value: 1,
        label: 'Ja',
    },
    {
        value: 0,
        label: 'Nein',
    },
];

export const EMPLOYMENT_TYPE_OPTIONS: SelectOption[] = [
    {
        value: 0,
        label: 'Hauptarbeitgeber',
    },
    {
        value: 1,
        label: 'Nebenarbeitgeber',
    },
];

export const MONTH_OPTIONS: Record<string, string> = monthNames.reduce((acc, month, index) => ({ ...acc, [index + 1]: month }), {});

export const JOB_STATUS_OPTIONS = {
    1: 'Arbeitgeber/Firmeninhaber',
    2: 'Beamtenanwärter',
    3: 'Behinderte zur Teilhabe am Arbeitsleben § 49 Abs. 3 Nr. 4 SGB IX',
    4: 'Behinderte Menschen § 55 Abs. 2 SGB IX',
    5: 'Duales Studium (berufsintegriert/-begleitend)',
    6: 'Ein-Euro-Job',
    7: 'Entliehene Arbeitnehmer',
    8: 'Fortzubildende, Volontäre und dergleichen',
    9: 'Freie Mitarbeiter',
    10: 'Geschäftsführer',
    11: 'Heimarbeiter',
    12: 'Orientierungspraktikum',
    13: 'Personen im Vorruhestand',
    14: 'Personen nach ständiger Übung in Stelle gewählt',
    15: 'Rechts-, Studienreferendare mit Anspruch auf Einstellung',
    16: 'Ruhendes Arbeitsverhältnis (Vertretung eingestellt)',
    17: 'Tätigkeit dient nicht in erster Linie zum Erwerb',
};

export const EMPLOYEE_PERSON_GROUP_TYPE: Record<EmployeePersonGroup, string> = {
    101: '101 - SV-pflichtig Beschäftigte ohne besondere Merkmale',
    102: '102 - Auszubildende',
    103: '103 - Beschäftigte in Altersteilzeit',
    104: '104 - Hausgewerbetreibende',
    105: '105 - Praktikanten',
    106: '106 - Werkstudenten',
    107: '107 - Jugendhilfe oder in Werkstätte für behinderte Menschen',
    108: '108 - Bezieher von Vorruhestandsgeld',
    109: '109 - Geringfügig entlohnte Beschäftigte',
    110: '110 - Kurzfristig Beschäftigte',
    111: '111 - Berufsfördernde Maßnahmen zu Reha.',
    112: '112 - Mitarbeitende Familienangehörige in der Landwirtschaft',
    113: '113 - Nebenerwerbslandwirte',
    114: '114 - Nebenerwerbslandwirte saisonal beschäftigt',
    116: '116 - Ausgleichsgeldempf. nach FELEG',
    118: '118 - Unständig Beschäftigte',
    119: '119 - Vesicherungsfreie Altersvollrentner',
    190: '190 - Ausschließlich in der gesetzlichen UV versicherte Beschäftigte',
    901: '901 - Nicht sv-pflichtige Beschäftigte, Sonderfälle',
};

export const  SOCIAL_SECURITY_TYPE_OPTIONS = {
    0: 'Keine Rente',
    1: '1 - Rentenantrag/Versorgungsausgleich',
    2: '2 - Teilweise Erwerbsminderung',
    3: '3 - Volle Erwerbsminderung',
    4: '4 - Altersvollrente',
    5: '5 - Altersteilrente',
    6: '6 - Hinterbliebenenrente',
    7: '7 - Erziehungsrente',
    8: '8 - Bergleute/Knappschaftsleute',
    9: '9 - Vorzeitige Altersrente',
};
export const  MEDICAL_AID_CONTRIBUTION_GROUP_OPTIONS = {
    0: '0 - Kein Beitrag',
    1: '1 - Allgemeiner Beitrag',
    2: '2 - Erhöhter Beitrag',
    3: '3 - Ermäßigter Beitrag',
    4: '4 - Beitrag zur Landwirtschaftl. KV',
    5: '5 - Arbeitgeberbeitrag zur landw. KV',
    6: '6 - Geringfügig Beschäftigte',
    9: '9 - Freiwillige KV (Firmenzahler)',
};
export const  SOCIAL_SECURITY_APPORTIONMENT_OPTIONS = {
    0: 'Keine Umlage',
    1: 'Nur Umlage 2',
    2: 'Umlage 1 und 2',
};
export const  SOCIAL_SECURITY_CONTRIBUTION_GROUP_OPTIONS = {
    0: '0 - Kein Beitrag',
    1: '1 - Voller Beitrag',
    3: '3 - Halber Beitrag',
    5: '5 - Pauschalbeitrag geringf. Beschäftigte',
};
export const  NURSING_CARE_INSURANCE_CONTRIBUTION_GROUP_OPTIONS = {
    0: '0 - Kein Beitrag',
    1: '1 - Voller Beitrag (AG/AN je 50%)',
    2: '2 - Halber Beitrag (AG/AN je 50 %)',
    3: '3 - Voller Beitrag (AG/AN je 50 %) AN überweist',
    4: '4 - Halber Beitrag (AN 100%)',
    5: '5 - Voller Beitrag (AN 100%)',
};
export const  UNEMPLOYMENT_INSURANCE_CONTRIBUTION_GROUP_OPTIONS = {
    0: '0 - Kein Beitrag',
    1: '1 - Voller Beitrag',
    2: '2 - Halber Beitrag',
};
export const  TRANSITION_ZONE_OPTIONS = {
    0: 'Nein',
    1: 'KV/PV/RV/AV',
    3: 'AV',
};